import { render } from "./PaymentEditPage.vue?vue&type=template&id=5a0582a6"
import script from "./PaymentEditPage.vue?vue&type=script&lang=js"
export * from "./PaymentEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__